const VienneseWaltzLead = {
    name: "Viennese Waltz",
    bpm: 156,
    signature: "6/8",
    introMeasures: 8,
    pattern: [

    ]
};

export default VienneseWaltzLead;